module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_13.eef5e4db.jpg";